


















import Vue from 'vue';
import DvFilterPopover from '@/components/util/DvFilterPopover.vue';
import { ITEM_RANKS } from '@/models/items/itemRanks';

interface IEntry {
    id: number;
    label: string;
    selected: boolean;
}

interface IData {
    entries: IEntry[];
}

function generateEntries(): IEntry[] {
    return ITEM_RANKS.map((r) => ({ id: r.id, label: r.label, selected: true }));
}

export default Vue.extend({
    components: {
        DvFilterPopover,
    },
    data(): IData {
        return {
            entries: generateEntries(),
        };
    },
    mounted() {
        this.syncQuery();
    },
    watch: {
        $route() {
            this.syncQuery();
        },
    },
    computed: {
        selectedCount(): number {
            const selected = this.entries.filter((v) => v.selected).length;
            return selected === this.entries.length ? 0 : selected;
        },
    },
    methods: {
        toggle(evt: InputEvent, entry: IEntry) {
            const target = evt.target as HTMLInputElement;
            entry.selected = target.checked;
            this.compute();
        },
        //  skipCompute mirrors ItemSearchCategorySelector/PartSelector's
        //  selectNone(skipCompute), NOT ItemSearchTypeSelector's select()
        //  (which has no such escape hatch -- see syncQuery below for why
        //  that matters). Without it, syncQuery's "clear everything, then
        //  re-mark the restored subset" two-step emits a SPURIOUS
        //  select([]) from the clearing step, which the parent's sameIdSet
        //  guard cannot suppress (filter.ranks still holds the real,
        //  non-empty selection at that instant) -- the parent then pushes
        //  ranks=[] to the URL, which re-triggers this selector's own
        //  $route watcher, which reconstructs the real selection and emits
        //  it again, which pushes the URL back, forever. Reproduced live
        //  (an unbroken g=5,7 / g= ping-pong against duck) before adding
        //  this guard; see task-7-report.md fix round 3.
        select(set: boolean, skipCompute = false) {
            this.entries.forEach((v) => v.selected = set);
            if (!skipCompute) {
                this.compute();
            }
        },
        compute() {
            const ret = this.entries.filter((v) => v.selected).map((v) => v.id);
            const res = ret.length === this.entries.length ? [] : ret;
            this.$emit('select', res);
        },
        syncQuery() {
            const q = this.$route.query;

            function extractNumericArray(v: any): number[] {
                if (v == null || v === '') {
                    return [];
                }
                return v.split(',').map(Number);
            }

            //  ranks travel in `g=`, matching searchParamsToQueryObject's
            //  `g: params.ranks.join(',')` and browseQuery's `filterToQuery`
            //  (`if (f.ranks.length) q.g = f.ranks.join(',')`).
            const rawRanks = extractNumericArray(q.g);
            if (rawRanks.length === 0) {
                this.select(true);
            } else {
                this.select(false, true);
                for (const e of this.entries) {
                    const idx = rawRanks.findIndex((v) => v === e.id);
                    if (idx !== -1) {
                        e.selected = true;
                    }
                }
                this.compute();
            }
        },
    },
});
